export default "__VITE_ASSET__CThryYKK__"